import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import login from '@/components/login'
import index from '@/components/index'
import courseDetail from '@/components/courseDetail'
import mine from '@/components/mine'
import project from '@/components/project'
import works from '@/components/works'
import score from '@/components/score'
import notice from '@/components/notice'
import noticeDetail from '@/components/noticeDetail'
import study from '@/components/study'
import liveRoom from '@/components/liveRoom'
import liveProjectDetail from '@/components/liveProjectDetail'

Vue.use(Router).use(ElementUI)

export default new Router({
    routes: [
        // {
        //   path: '/login',
        //   name: 'login',
        //   component: login
        // },
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            requireAuth: ''
        },
        {
            path: '/courseDetail',
            name: 'courseDetail',
            component: courseDetail,
            requireAuth: ''
        },
        {
            path: '/mine',
            name: 'mine',
            component: mine,
            requireAuth: ''
        },
        {
            path: '/project',
            name: 'project',
            component: project,
            requireAuth: ''
        },
        {
            path: '/works',
            name: 'works',
            component: works,
            requireAuth: ''
        },
        {
            path: '/score',
            name: 'score',
            component: score,
            requireAuth: ''
        },
        {
            path: '/notice',
            name: 'notice',
            component: notice,
            requireAuth: ''
        },
        {
            path: '/noticeDetail',
            name: 'noticeDetail',
            component: noticeDetail,
            requireAuth: ''
        },
        {
            path: '/study',
            name: 'study',
            component: study,
            requireAuth: ''
        },
        {
            path: '/liveRoom',
            name: 'liveRoom',
            component: liveRoom,
            requireAuth: ''
        },
        {
            path: '/liveProjectDetail',
            name: 'liveProjectDetail',
            component: liveProjectDetail,
            requireAuth: ''
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js